import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const faqData = [
  {
    question: "How does it works?",
    answer: "Imperdiet ut tristique viverra nunc. Ultrices orci vel auctor cursus turpis nibh placerat massa. Fermentum urna ut at et in. Turpis aliquet cras hendrerit enim condimentum. Condimentum interdum risus bibendum urna. Augue aliquet varius faucibus ut integer tristique id. Pellentesque id nibh sed nulla non nulla."
  },
  {
    question: "Can I rent a car without a credit card?",
    answer: "Yes, but it often requires a larger deposit and additional verification. Please contact our support team for specific requirements based on your location and the car type."
  },
  {
    question: "What are the requirements for renting a car?",
    answer: "You generally need a valid driver's license, a credit card in your name, and must be over 21 years of age. Some locations and car types may have different age requirements."
  },
  {
    question: "Does Car Rental allow me to tow with or attach a hitch to the rental vehicle?",
    answer: "No, towing is not permitted with any of our rental vehicles. This is to ensure the safety and maintenance of our fleet."
  },
  {
    question: "Does Car Rental offer coverage products for purchase with my rental?",
    answer: "Yes, we offer a variety of optional coverage products, including a Collision Damage Waiver (CDW), Supplemental Liability Protection (SLP), and Personal Accident Insurance (PAI)."
  }
];

const FaqItem = ({ question, answer, isOpen, onToggle }) => (
  <div className="bg-white rounded-lg shadow-md transition-all duration-300 ease-in-out transform hover:scale-105">
    <button
      onClick={onToggle}
      className="w-full flex justify-between items-center p-5 md:p-6 text-left"
    >
      <h3 className="text-base md:text-lg font-semibold text-black">{question}</h3>
      {isOpen ? <FaChevronUp className="text-amber-500 flex-shrink-0" /> : <FaChevronDown className="text-gray-400 flex-shrink-0" />}
    </button>
    {isOpen && (
      <div className="p-5 md:p-6 pt-0">
        <p className="text-gray-700 text-sm">{answer}</p>
      </div>
    )}
  </div>
);

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0); 

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-gray-100 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-black mb-12">
          Top Car Rental Questions
        </h2>
        <div className="space-y-4">
          {faqData.map((item, index) => (
            <FaqItem 
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;